import { useCallback } from 'react';
import { AccountFeatureAPI } from 'api/account-feature';
import { toastService } from 'components/molecules/toast';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { TranslationKey, useTranslate } from 'hooks/use-translation';

export const useFeatureSettings = (): [boolean, (state: boolean) => void] => {
  const translate = useTranslate();

  const [featureenabled, setFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );

  const onFeatureStateChange = useCallback(
    (newState: boolean) => {
      setFeatureEnabled(newState);
      if (newState) {
        AccountFeatureAPI.enableFeature(AccountFeature.Timesheets)
          .then(() => {
            toastService({
              title: translate('success' as TranslationKey),
              message: translate(
                'settings.timesheets.enable.success' as TranslationKey,
              ),
            }).success();
          })
          .catch(() => {
            setFeatureEnabled(!newState);
            toastService({
              title: translate('failure' as TranslationKey),
              message: translate(
                'settings.timesheets.enable.failure' as TranslationKey,
              ),
            }).error();
          });
      } else {
        AccountFeatureAPI.disableFeature(AccountFeature.Timesheets)
          .then(() => {
            toastService({
              title: translate('success' as TranslationKey),
              message: translate(
                'settings.timesheets.disable.success' as TranslationKey,
              ),
            }).success();
          })
          .catch(() => {
            setFeatureEnabled(!newState);
            toastService({
              title: translate('failure' as TranslationKey),
              message: translate(
                'settings.timesheets.disable.failure' as TranslationKey,
              ),
            }).error();
          });
      }
    },
    [setFeatureEnabled, translate],
  );

  return [featureenabled, onFeatureStateChange];
};
